import {appConfig} from '~/config';

const API_VERSION = appConfig.api.version;

export const apiBaseUrl = `${API_VERSION}/api/v1`;
export const apiAppointment = `${appConfig.appointmentApi.host}/api/v1`;

export const MQ_ENDPOINTS = {
  QUESTIONNAIRES: `/${apiBaseUrl}/medical-questionnaires`,
  FILE_UPLOAD: `/${apiBaseUrl}/medical-questionnaires/s3/upload`,
  APPOINTMENT_TIME: `${apiAppointment}/bookings/available-times`,
  APPOINTMENT_DATE: `${apiAppointment}/bookings/available-dates`,
  BOOKING_APPOINTMENT: `${apiAppointment}/bookings/appointments`,
};

export const STUDENT_ENDPOINTS = {
  STUDENT_REGISTERS: `/${apiBaseUrl}/students/registers`,
  UPLOAD: `/${apiBaseUrl}/students/student-id/upload`,
  AMBASSADOR_REGISTER: `/${apiBaseUrl}/students/ambassador-registers`,
  SCHOOLS: `/${apiBaseUrl}/students/schools`,
};

export const ENDPOINTS = {
  LOGIN: `login`,
  SOCIAL_LOGIN: `auth/social/login`,
  LOGOUT: `auth/logout`,
  CURRENT_USER: `me`,
  MEDICATIONS: `medications`,
  USERS: `users`,
  TABLE_STATES: `users/table_states`,
  TABLE_STATES_DELETE: `users/table_states/delete`,
  FILE_UPLOAD: 'uploads/images',
  ADMINS: 'admins',
  ROLES: 'roles',
  USER_ROLES: 'users/roles',
  GROUPS: 'groups',
  REPORTS: 'reports',
  COMMENTS: 'comments',
  TOPICS: 'topics',
  COMMUNITY: 'community',
  FEEDBACKS: 'feedbacks',
  PERMISSIONS: 'permissions',
  PATIENT_ROSTERS: 'patient_roster',
  USER_ACTIVITY_LOGS: 'user-activity-logs',
  OPERATION_ORDERS: 'operation-orders',
  REPORT_DASHBOARD: 'reports/dashboard',
};
